/* global theme */
(function () {
  const GIFT_PROPERTY_KEY = '_free_gift';
  let discountValidationFailed = false;

  function findGiftCard() {
    return document.querySelector('[data-cart-free-gift]');
  }

  function getCart() {
    return fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' }
    }).then((r) => r.json());
  }

  function findGiftLine(cart) {
    return cart.items.find(
      (item) => item.properties && String(item.properties[GIFT_PROPERTY_KEY]) === 'true'
    );
  }

  function dispatchCartChange() {
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
  }

  async function addGift(variantId) {
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: { [GIFT_PROPERTY_KEY]: 'true' }
          }
        ]
      })
    });
    if (!res.ok) return false;

    // Verificação crítica: o desconto "Compre X, ganhe Y" do Shopify Admin precisa
    // ter zerado o preço da garrafa. Se entrou com valor, removemos imediatamente
    // para não cobrar o cliente.
    const cart = await getCart();
    const giftLine = findGiftLine(cart);
    if (giftLine && giftLine.final_line_price > 0) {
      await removeGift(giftLine.key);
      discountValidationFailed = true;
      // eslint-disable-next-line no-console
      console.error(
        '[cart-free-gift] Brinde removido: o desconto automático do Shopify NÃO aplicou (linha ficou com R$ ' +
          (giftLine.final_line_price / 100).toFixed(2) +
          '). Verifique no Admin → Descontos → "Ganhe uma garrafa..." se "O cliente recebe (Y)" aponta para o produto correto a 100% off, e se o tipo é "Desconto automático".'
      );
      return false;
    }
    return true;
  }

  function removeGift(lineKey) {
    return fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  // Mantém quantidade da linha do brinde travada em 1
  async function enforceGiftQuantity(cart) {
    const giftLine = findGiftLine(cart);
    if (giftLine && giftLine.quantity !== 1) {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 1 })
      });
      return true;
    }
    return false;
  }

  // Marca a linha do brinde no DOM para travar controles via CSS
  function tagGiftLineInDom() {
    document.querySelectorAll('.cart-item').forEach((el) => {
      const propsText = el.textContent || '';
      if (propsText.indexOf('_free_gift') !== -1) {
        el.setAttribute('data-free-gift-line', '');
      }
    });
  }

  async function syncGiftState() {
    const card = findGiftCard();
    if (!card) return;

    if (card.dataset.giftBusy === '1') return;
    card.dataset.giftBusy = '1';

    try {
      const cart = await getCart();
      const giftLine = findGiftLine(cart);

      // PRIORIDADE INVERTIDA (2026-05-26): garrafa vence sobre chaveiro.
      // Quando cart qualifica para ambos (≥2 RG E subtotal >= min_amount),
      // Promo 2 detecta isso (via cartQualifiesForGarrafa) e remove o chaveiro
      // do próprio cart no próximo sync. Promo 1 não precisa fazer nada extra —
      // segue fluxo normal de adicionar/remover garrafa pelo subtotal.

      // Calcula subtotal SEM o brinde
      let subtotalExclGift = cart.total_price;
      if (giftLine) subtotalExclGift -= giftLine.final_line_price;

      const minAmount = parseInt(card.dataset.giftMinAmount, 10);
      const variantId = card.dataset.giftVariantId;

      // Salvaguarda: se há uma linha de brinde com preço > 0, é porque o desconto
      // automático do Shopify não está aplicando. Remove sempre para não cobrar
      // o cliente, independente de quando foi adicionada. Não setamos o flag
      // discountValidationFailed aqui — ele é setado só quando uma nova tentativa
      // de addGift falha (assim, restos de testes anteriores não bloqueiam o
      // auto-add para sempre na sessão).
      if (giftLine && giftLine.final_line_price > 0) {
        await removeGift(giftLine.key);
        // eslint-disable-next-line no-console
        console.warn(
          '[cart-free-gift] Brinde removido (não estava grátis - R$ '
            + (giftLine.final_line_price / 100).toFixed(2)
            + '). Pode ser resto de teste anterior; será readicionado se o limite ainda estiver atingido.'
        );
        dispatchCartChange();
        return;
      }

      // Trava qty=1 caso alguém aumente
      const wasEnforced = await enforceGiftQuantity(cart);
      if (wasEnforced) {
        dispatchCartChange();
        return;
      }

      // Subtotal caiu abaixo do mínimo e brinde está no carrinho → remove
      if (giftLine && subtotalExclGift < minAmount) {
        await removeGift(giftLine.key);
        dispatchCartChange();
        return;
      }

      // Subtotal atingiu o mínimo e o brinde NÃO está no carrinho → adiciona automaticamente
      // (mas não tenta de novo se o desconto já falhou nesta sessão)
      if (
        card.dataset.giftAutoAdd !== 'false'
        && !giftLine
        && subtotalExclGift >= minAmount
        && !discountValidationFailed
      ) {
        card.classList.add('is-loading');
        await addGift(variantId);
        dispatchCartChange();
        return;
      }

      tagGiftLineInDom();
    } catch (e) {
      // silencioso — não impede o fluxo do carrinho
      // eslint-disable-next-line no-console
      console.warn('[cart-free-gift]', e);
    } finally {
      card.dataset.giftBusy = '';
    }
  }

  // Sincroniza após qualquer mudança no carrinho
  document.addEventListener('on:cart:after-merge', syncGiftState);
  document.addEventListener('on:cart:add', syncGiftState);

  // Sincronização inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGiftState);
  } else {
    syncGiftState();
  }
})();
